module.exports = __webpack_public_path__ + "5f3dd5b30b33ed8172f477f236fc5243.pdf";